import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { BiSearch } from 'react-icons/bi';
import { Link, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useCurrent } from '../hooks';
import { MwInputText, MwSpinnerButton } from './ui';

const SearchVendor = ({ className, onChangeSearch = () => {}, isOpen = true }) => {
    const { currentTenantId, currentCompanyId, currentBranchId, currentLangId } = useCurrent();
    const token = localStorage.getItem('token');
    const [t] = useTranslation('global');

    const params = useParams();
    const [term, setTerm] = useState();
    const [dataResult, setDataResult] = useState([]);
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);

    const onChangeHandler = (e) => {
        setTerm(e.target.value);
    };

    const getResult = async () => {
        isOpen && setShow(true);
        setLoading(true);

        const response = await axios.get(
            `${process.env.REACT_APP_VENDORS_API_BASE_URL}/name/${currentTenantId}/${currentCompanyId}/${currentBranchId}/${term}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        const result = response?.data?.data || [];
        setLoading(false);
        setDataResult(result);
        onChangeSearch(result);
    };

    useEffect(() => {
        if (!term) {
            setShow(false);
        }

        const timeout = setTimeout(() => {
            if (term) {
                getResult();
            }
        }, 1000);

        return () => {
            clearTimeout(timeout);
        };
    }, [term]);

    return (
        <div className='flex-1'>
            <div
                onClick={() => term && setShow(!show)}
                className={`relative ${show && 'border-t border-s border-e rounded-lg'}`}
            >
                <BiSearch className='absolute top-2 start-3' size={16} />
                <MwInputText
                    classNameInput={`bg-slate-50 rounded-lg ${className}`}
                    placeholder={t('vendors.searchVendor')}
                    value={term}
                    onChange={onChangeHandler}
                />
            </div>

            {show && (
                <div className='absolute top-9 z-50 h-48 w-full overflow-y-auto rounded-b-lg border-b border-s border-e bg-slate-50 opacity-95 lg:w-[420px]'>
                    {!loading ? (
                        dataResult.length > 0 ? (
                            <ul>
                                <li className='flex justify-between border-b p-2 text-xs'>
                                    <div className='w-24 px-1 text-center'>
                                        {t('vendors.vendorNumber')}
                                    </div>
                                    <div className='flex-1'>{t('vendors.vendorName')}</div>
                                </li>

                                {dataResult.map((result) => (
                                    <Link
                                        target='_blank'
                                        to={`/${params.tenant}/vendors/show/${result?._id}/${result?.companyId}/${result?.branchId}`}
                                        key={result._id}
                                    >
                                        <li className='flex justify-between border-b p-2 text-xs hover:bg-indigo-50 hover:font-bold'>
                                            <div className='w-24 px-1 text-center'>
                                                {result.vendorNo || result.customerNo}
                                            </div>
                                            <div className='flex-1'>
                                                {result?.fullname?.find((item) => item.lang === currentLangId)
                                                    ?.text ||
                                                    result?.fullname?.[0]?.text ||
                                                    result?.fullname?.[1]?.text}
                                            </div>
                                        </li>
                                    </Link>
                                ))}
                            </ul>
                        ) : (
                            <div className='p-5 text-center'>{t('DashBoard.noResults')}</div>
                        )
                    ) : (
                        <MwSpinnerButton withLabel={false} isFullCenter={true} />
                    )}
                </div>
            )}
        </div>
    );
};

export default SearchVendor;
